/**
 * Ações de combate: o catálogo — o que existe, com que custo, o que se começa sabendo
 * e como se aprende o resto.
 *
 * <p><b>A fonte do catálogo é a planilha do Theo</b> ("Ações de Combate.xlsx",
 * 22/08/2026), transcrita integralmente em quatro quadros: básicas (COMUNS), o bloco
 * AGUARDO (sem classificação — ele distribui), avançadas (ESPECIAIS) e as de Criaturas
 * (ANIMAIS). O motor da luta — rodada, iniciativa, PA, distância, reações — mora na
 * página Combate.
 *
 * <p>Mesmo padrão das irmãs ({@link PaginaEmDuasAbas}): duas abas com documento
 * próprio, índice, macro-títulos, títulos/prosa/tabelas editáveis e ícones. O conteúdo
 * de fábrica mora em {@link ./conteudoDeAcoesDeCombate}; o que o time gravar vence.
 */
import { GRUPOS, GRUPOS_S2, SECOES, SECOES_S2, TABELAS, TABELAS_S2 } from './conteudoDeAcoesDeCombate';
import { PaginaEmDuasAbas } from './PaginaEmDuasAbas';
import { PAGINAS } from './rascunhoDeGameDesign';

export function AcoesDeCombate() {
  return (
    <PaginaEmDuasAbas
      beta={{
        chave: PAGINAS.acoesDeCombate,
        tabelas: TABELAS,
        secoes: SECOES,
        grupos: GRUPOS,
        subtitulo:
          'O catálogo da planilha, integral: básicas, avançadas e de criaturas — e como uma ação se aprende.',
      }}
      season2={{
        chave: PAGINAS.acoesDeCombateSeason2,
        tabelas: TABELAS_S2,
        secoes: SECOES_S2,
        grupos: GRUPOS_S2,
        subtitulo: 'O que fica para depois: a Carta como feito que desbloqueia uma ação.',
      }}
    />
  );
}
